import { render, staticRenderFns } from "./tools_admission.vue?vue&type=template&id=90aa363a&scoped=true"
import script from "./tools_admission.vue?vue&type=script&lang=js"
export * from "./tools_admission.vue?vue&type=script&lang=js"
import style0 from "./tools_admission.vue?vue&type=style&index=0&id=90aa363a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90aa363a",
  null
  
)

export default component.exports